import { action, makeObservable, observable } from "mobx";
import { IFreeBet } from "../interfaces/free-bet";

export interface IConnectionLost {
  /** Translation key of the heading; "Connection lost" when not set. */
  title?: string;
  /** Translation key shown to the player. */
  message: string;
  /** Tells developers looking at a screenshot which failure this was. */
  code: string;
  time: Date;
  /** Whether the player can reload to try again. */
  canReconnect: boolean;
}

export interface IConnectionLostOptions {
  title?: string;
  canReconnect?: boolean;
}

class UtilsStore {

  gameId: number | null = null;
  freeBetEndData: IFreeBet | undefined;
  freeBetAwardData: IFreeBet | undefined;
  connectionLost: IConnectionLost | null = null;

  constructor() {
    makeObservable(this, {
      freeBetEndData: observable,
      freeBetAwardData: observable,
      connectionLost: observable,
      setFreeBetEndData: action.bound,
      setFreeBetAwardData: action.bound,
      setConnectionLost: action.bound,
    });
  }

  setGameId = (gameId: number | null) => {
    this.gameId = gameId;
  }

  setFreeBetEndData = (freeBetEndData: IFreeBet | undefined) => {
    this.freeBetEndData = freeBetEndData;
  }

  setFreeBetAwardData = (freeBetAwardData: IFreeBet | undefined) => {
    this.freeBetAwardData = freeBetAwardData;
  }

  setConnectionLost = (message: string, code: string, options: IConnectionLostOptions = {}) => {
    this.connectionLost = { message, code, time: new Date(), title: options.title, canReconnect: options.canReconnect ?? true };
  }

}

export const utilsStore = new UtilsStore();